module.exports = __webpack_public_path__ + "img/design.807d1a57.png";